import { render, staticRenderFns } from "./admin-inactive-2025.vue?vue&type=template&id=f286763c&scoped=true"
import script from "./admin-inactive-2025.vue?vue&type=script&lang=js"
export * from "./admin-inactive-2025.vue?vue&type=script&lang=js"
import style0 from "./admin-inactive-2025.vue?vue&type=style&index=0&id=f286763c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f286763c",
  null
  
)

export default component.exports